import { useMutation, useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import moment from "moment";

import {
  FETCH_PLAN_AND_ODOO_SALES_ORDER_DETAIL,
  SYNC_PLAN_TO_ODOO,
} from "./graphql";
import PlanOdooSoView from "./PlanOdooSOView";
import { computePlanLinesWithOdooInfo } from "./utils";

const SyncPlanToSoView = ({ planId, odooObject, didSyncedToOdoo }) => {
  const { loading, error, data } = useQuery(
    FETCH_PLAN_AND_ODOO_SALES_ORDER_DETAIL,
    {
      variables: { ids: [odooObject.objectId], planId },
      fetchPolicy: "network-only",
    },
  );
  const [sync, syncRes] = useMutation(SYNC_PLAN_TO_ODOO, {
    variables: { planId, instance: "AB" },
    onCompleted() {
      Alert("success", "Sync Success");
      didSyncedToOdoo();
    },
    onError(error) {
      Alert("error", error.message);
    },
    refetchQueries: [FETCH_PLAN_AND_ODOO_SALES_ORDER_DETAIL],
    awaitRefetchQueries: true,
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const odooSo = JSON.parse(data.odooSo)[0];
  console.log("odooSo", odooSo);
  const { planLines, odooLinesWithNotFoundInPlanLines, isSynced } =
    computePlanLinesWithOdooInfo(data.productionPlan, odooSo);
  console.log("planLines", planLines);

  return (
    <div>
      <div className="-mx-2">
        <PlanOdooSoView
          planLines={planLines}
          odooLinesWithNotFoundInPlanLines={odooLinesWithNotFoundInPlanLines}
        />
      </div>

      <div className="flex space-x-3 mt-6">
        <label>Estimated Ready Date: </label>
        <span>
          {moment(data.productionPlan.finalReadyDate).format("YYYY-MM-DD")}
        </span>
      </div>

      <div className="mt-8 text-sm text-orange-600 font-semibold leading-relaxed">
        <p>Note ⚠️</p>
        <p>
          Odoo does not support deleting items in a confirmed Sales Order or
          Internal Transfer. You should rather reduce the original quantity to
          0.
        </p>
        <p>
          Make sure you double check the Sales Order or Internal Transfer in
          Odoo after sync!!
        </p>
      </div>

      {isSynced ? (
        <div className="mt-8 text-green-600 font-semibold">
          ✅ This plan is Synced with Odoo -{" "}
          {data.productionPlan.odooObject.objectName}
        </div>
      ) : null}

      <div className="mt-8">
        <Button primary loading={syncRes.loading} onClick={sync}>
          Sync to {data.productionPlan.odooObject.objectName}
        </Button>
      </div>
    </div>
  );
};

export default SyncPlanToSoView;
